module.exports = {
    base: "/v1",
    mock: "/mock"
};